<script>
    //Events to emit so '.native' is not necessary
    let events = ['change', 'keyup', 'keydown', 'keypress', 'copy', 'cut', 'paste'];

    export default {
        props: ["value", "saved"],
        methods: {
            valueChanged(e) {
                this.changed = true;
            }
        },
        data() {
            return {
                changed: false
            }
        },
        mounted() {
            events.forEach(event => 
                this.$refs.input.addEventListener(event, e => 
                    this.$emit(event, e)
                )
            );
        },
        watch: {
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        }
    }
</script>
<template>
    <input ref="input" @change="valueChanged" @input="$emit('input', $event.target.value)" :value="value">
</template>

<style lang="less" scoped>
    input {
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        border-radius: 2px;
        height: 40px;
        border: 1px solid #d6d7d5;
        font-size: 16px;
        padding-top: 8px;
    }

    body.user-is-tabbing {
        input:focus {
            border: 4px solid #aaa !important;
        }
    }
</style>